import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThLarge } from '@fortawesome/pro-regular-svg-icons/faThLarge';

// FontAwesome regular (outlined) th-large icon — 2x2 grid of squares.
// Wrapped so it conforms to the same component-with-no-props contract as
// the other nav icons in this directory (rendered as <IconComponent />
// by NavIcon).
const StyledIcon = styled(FontAwesomeIcon)`
  height: 16px;
  width: 16px;
`;

export default function ThLarge() {
  return <StyledIcon icon={faThLarge} />;
}
